import React from 'react';
import { IMAGE_UPLOAD_ACCEPT_ATTR } from '../../../utils/imageUploadCompatibility';
type Props = {
  flyerFileInputsRef: React.MutableRefObject<Record<string, HTMLInputElement | null>>;
  bannerFileInputRef: React.Ref<HTMLInputElement>;
  performanceFlyerInputRef: React.Ref<HTMLInputElement>;
  onFlyerChange: (side: string, event: React.ChangeEvent<HTMLInputElement>) => void;
  onBannerChange: React.ChangeEventHandler<HTMLInputElement>;
  onPerformanceChange: React.ChangeEventHandler<HTMLInputElement>;
};
export default function EventAssetFileInputs({
  flyerFileInputsRef,
  bannerFileInputRef,
  performanceFlyerInputRef,
  onFlyerChange,
  onBannerChange,
  onPerformanceChange
}: Props) {
  return <>
    {['front', 'back'].map(side => <input key={side} type="file" accept={IMAGE_UPLOAD_ACCEPT_ATTR} style={{ display: 'none' }} ref={el => {
      flyerFileInputsRef.current[side] = el;
    }} onChange={event => onFlyerChange(side, event)} />)}
    <input type="file" accept={IMAGE_UPLOAD_ACCEPT_ATTR} style={{ display: 'none' }} ref={bannerFileInputRef} onChange={onBannerChange} />
    <input type="file" accept={IMAGE_UPLOAD_ACCEPT_ATTR} style={{ display: 'none' }} ref={performanceFlyerInputRef} onChange={onPerformanceChange} />
  </>;
}
